import React from 'react';
export const IconLeft = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.999994 12.047L12 23L14.2516 20.7581L5.50306 12.047L14.2515 3.33595L12 1.09406L0.999994 12.047Z"
      fill="#C4964D"
    />
    <rect
      width="6.35459"
      height="6.35459"
      transform="matrix(-0.70862 -0.70559 0.70862 -0.70559 14.5093 16.5311)"
      fill="#C4964D"
    />
  </svg>
);
